const AYL_SELLER_ID_REGEX = /{{ayl_seller_id}}/g;
const SELLER_ID_REGEX = /{{seller_id}}/g;

export const getSellerIdToUse = (sellerId, sellerIdOverrides, spotId) =>
  !sellerId || sellerIdOverrides.includes(sellerId) ? spotId : sellerId;

export const processSellerId = (adsText, sellerId) => adsText.replace(SELLER_ID_REGEX, sellerId);

export const processAylSellerId = (adsText, aylSellerId) =>
  aylSellerId
    ? adsText.replace(AYL_SELLER_ID_REGEX, aylSellerId)
    : adsText
        .split('\n')
        .filter(item => !new RegExp(AYL_SELLER_ID_REGEX).test(item))
        .join('\n');

export const getProcessedAdsText = (adsText, sellerId, aylSellerId) => {
  const partiallyProcessedAdsText = processSellerId(adsText, sellerId);

  return processAylSellerId(partiallyProcessedAdsText, aylSellerId);
};
